/* eslint-disable  */
export const saveAccountCardData = (data) => ({
  type: 'STORE_ACCOUNT_CARD_DATA',
  data,
});
